window.toastr = window.toastr || require('toastr')

//Used for Folders
function displayToastr(type, message) {
  toastr.options.closeButton = false
  toastr.options.allowHtml = true
  toastr.options.escapeHtml = false

  if (type === 'success') {
    toastr.options.timeOut = 4000
    toastr.success(message)
  }
  if (type === 'error') {
    toastr.options.timeOut = 0
    toastr.options.closeButton = true
    toastr.error(message)
  }
}

//On DOM loaded
$(document).ready(function () {
  //Canvas.onLoadBrowserTagging();
  //Dropdowns that change something via ajax (if they exist)
  if ($('.ajax_dropdown').length) {
    $('.ajax_dropdown').change(function () {
      var dropdown = $(this)
      var selected = this.options[this.selectedIndex]
      //set any additional variables other than the value from the selected item.
      var additional_params = dropdown.data('params')
        ? '&' + dropdown.data('params')
        : ''

      $.ajax({
        method: dropdown.data('method') ? dropdown.data('method') : 'get',
        url: dropdown.data('url'),
        data: 'value=' + selected.value + additional_params,
        success: function (result) {
          displayToastr('success', result.html)
        },
        error: function () {
          displayToastr(
            'error',
            'An error occurred communicating with the server. We could not process the last update.'
          )
        },
      })
    })
  }

  //Do a javascript popup window
  $('a[data-popup]').on('click', function (event) {
    window.open(
      $(this).attr('href'),
      'Storage Integration',
      'height=600,width=450'
    )
    event.preventDefault()
  })

  //Use Jquery UJS data-confirm callback to set canvas wait screen if the appropriate element is provided.
  $(document).on('confirm:complete', function (event, answer) {
    if (answer) {
      var el = $(event.target).closest('a, input, button')
      if (el.data('wait')) {
        GC.loader.show_wait_screen({ element: el })
      }
    }
    return answer
  })

  //show wait screen, unless it's already handled by data-confirm above.
  $('[data-wait]:not([data-confirm])').click(function (event) {
    GC.loader.show_wait_screen({
      element: $(event.target).closest('a, input, button'),
    })
  })

  //Identify SelectAll Controls and bind functionality approprietely.
  $('[data-select-all-group]').map(function (i, el) {
    var element = $(el)
    var chkbx_group = $('.' + element.data('select-all-group'))

    //set values of group based on select all checked status
    element.click(function () {
      chkbx_group.prop('checked', this.checked)
      //trigger change event in case there is anything else that depends upon this.
      chkbx_group.change()
    })

    //set values of select all based on whether or not all of the group are checked or not.
    chkbx_group.click(function () {
      if (
        chkbx_group.length ==
        $('.' + element.data('select-all-group') + ':checked').length
      ) {
        element.prop('checked', true)
      } else {
        element.prop('checked', false)
      }
    })
  })
})

window.mobileAndTabletcheck = function () {
  var check = false
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  // console.log('check' + check);
  return check
}

function checkmedia() {
  if (
    !mobileAndTabletcheck() ||
    (mobileAndTabletcheck() && !window.matchMedia('(max-width: 991px)').matches)
  ) {
    if (window.matchMedia('(max-width: 991px)').matches) {
      resetSlider()
      managing_users_check()
      if (!$('#user-info').is(':visible')) {
        $('#side_nav').css('display', ' ')
      } else {
        $('#side_nav').hide()
      }
    } else if ($('#cancel-login-menu').length > 0) {
      resetSlider()
      managing_users_check()
    }
  }
}

function resetmultiSelect() {
  var mobileMuliselect = $('#filter').data('echMultiselect')
  if (mobileMuliselect != undefined) {
    if (window.matchMedia('(max-width: 991px)').matches) {
      mobileMuliselect.menu.addClass('m-mselect')
      mobileMuliselect.button.addClass('m-mselect-btn')
      mobileMuliselect.option('minWidth', 'auto')
    } else {
      mobileMuliselect.menu.removeClass('m-mselect')
      mobileMuliselect.button.removeClass('m-mselect-btn')
      mobileMuliselect.option('minWidth', $('#filter').parent().width())
      if (mobileMuliselect._isOpen) {
        mobileMuliselect.close()
      }
    }
  }
}
function disablefeature(eleClick, popupid) {
  if (window.localStorage.getItem('gocanvas-dnd-disabled') == 'true') {
    $(popupid).remove()
  } else if (eleClick) {
    $(popupid).remove()
    window.localStorage.setItem('gocanvas-dnd-disabled', true)
  }
}
function trialVisible() {
  /*if trial banner is visible**/
  var bannerDiv = $('#trial_banner')
  if (bannerDiv.is(':visible') && window.innerWidth < 992) {
    bannerDiv.find('button').addClass('border-all btn-white-hover')
    if (bannerDiv.hasClass('expired')) {
      bannerDiv.find('button').addClass('btn-danger')
    }
    $('main').css({ marginTop: bannerDiv.outerHeight() })
    var timer = null
    $(window).scroll(function () {
      if (timer !== null) {
        clearTimeout(timer)
      }
      timer = setTimeout(function () {
        if ($(window).scrollTop() >= 100) {
          bannerDiv.stop(true, false).animate({
            lineHeight: 15,
            height: 25,
          })
          bannerDiv.find('button').css({
            position: 'absolute',
            left: 0,
            right: 0,
            width: '100%',
            top: 0,
            padding: 3,
            opacity: 0,
          })
        } else if ($(window).scrollTop() <= 30) {
          bannerDiv.stop(true, false).animate(
            {
              height: 50,
              lineHeight: 40,
            },
            function () {
              $('main').animate({ marginTop: bannerDiv.outerHeight() })
              bannerDiv.find('button').removeAttr('style')
            }
          )
        }
      }, 50)
    })
  } else {
    $(window).off('scroll')
    bannerDiv.removeAttr('style')
    bannerDiv
      .find('button')
      .removeAttr('style')
      .removeClass('btn-danger border-all btn-white-hover')
    $('main').css({ marginTop: 0 })
  }
  if (
    bannerDiv.is(':visible') &&
    window.innerWidth > 992 &&
    window.innerWidth < 1085
  ) {
    $('.branding').css({ width: 41 })
  } else {
    $('.branding').removeAttr('style')
  }
}

GC.enqueue(function () {
  trialVisible()
  managing_users_check()
  disablefeature(null, '#al-pop')
  if (!mobileAndTabletcheck()) {
    //display custom title on element
    $('.action_control *[title]').tooltip({ animation: false })
    $('.action_control *[title]')
      .on('mousedown', function (e) {
        $(this).tooltip('destroy')
      })
      .on('mouseleave', function (e) {
        $(this).tooltip({ animation: false })
      })
  } else {
    $.smartbanner({
      title: 'GoCanvas', // What the title of the app should be in the banner (defaults to <title>)
      author: 'Canvas Solutions, Inc.', // What the author of the app should be in the banner (defaults to <meta name="author"> or hostname)
      price: 'Free', // Price of the app
      appStoreLanguage: 'us', // Language code for App Store
      inAppStore: 'On the App Store', // Text of price for iOS
      inGooglePlay: 'In Google Play', // Text of price for Android
      inAmazonAppStore: 'In the Amazon Appstore',
      inWindowsStore: 'In the Windows Store', // Text of price for Windows
      GooglePlayParams: null, // Aditional parameters for the market
      icon: '/images/favicon.ico', // The URL of the icon (defaults to <meta name="apple-touch-icon">)
      iconGloss: null, // Force gloss effect for iOS even for precomposed
      url: null, // The URL for the button. Keep null if you want the button to link to the app store.
      button: 'View', // Text for the install button
      scale: 'auto', // Scale based on viewport size (set to 1 to disable)
      speedIn: 300, // Show animation speed of the banner
      speedOut: 400, // Close animation speed of the banner
      daysHidden: 30, // Duration to hide the banner after being closed (0 = always show banner)
      daysReminder: 30, // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
      force: null, // Choose 'ios', 'android' or 'windows'. Don't do a browser check, just always show this banner
      hideOnInstall: true, // Hide the banner after "VIEW" is clicked.
      layer: false, // Display as overlay layer or slide down the page
      iOSUniversalApp: true, // If the iOS App is a universal app for both iPad and iPhone, display Smart Banner to iPad users, too.
      appendToSelector: 'body', //Append the banner to a specific selector
      onInstall: function () {
        // alert('Click install');
        resetHeader()
      },
      onClose: function () {
        //alert('Click close');
        resetHeader()
      },
    })
    checkBannerVisible('#smartbanner')
  }

  /** mobile app store filter slider**/
  $('label[for="appsfilter_"]').click(function () {
    appfilter()
  })
  /*end*/
  $(window).resize(function () {
    trialVisible()
    resetmultiSelect()
    /** adjust modal window on resize**/
    modalPopup()
    managing_users_check()
    /*** reste Nav and app filter ***/
    checkmedia()

    responsiveBreadCrumbs()
    /*** pagination**/
    mobiPaging()
  })

  $('#overlay_div').on('touchstart', function (e) {
    if ($('.app-filter').is(':visible')) {
      /** mobile app store filter slider**/
      appfilter()
    }
    var mobileMuliselect = $('#filter').data('echMultiselect')
    if (mobileMuliselect != undefined) {
      if (mobileMuliselect._isOpen) {
        mobileMuliselect.close()
      }
    }

    /*end*/
    return false
  })

  $('.modal').on('hidden.bs.modal', function (e) {
    $(this).find('.modal-header > *:not(".close,.modal-title")').remove()
    $(this).find('.modal-title, .modal-body, .modal-footer').empty()
    $('<i class="fa fa-spinner fa-pulse fa-3x fa-fw block center-block"></i>')
      .empty()
      .appendTo($(this).find('.modal-body'))
  })

  $('.btn').removeAttr('title')

  $(document).ajaxComplete(function (e) {
    modalPopup()
    mobiPaging()
  })

  /*Responsive Breadcrumbs will be applied ony when its container has breadcrumb-container class*/
  responsiveBreadCrumbs()

  mobiPaging()

  // enable href link if autofocus on input and validation fire
  $('a').on('mousedown', function () {
    // console.log('in');
    mousedownHappened = true
  })

  /**check page transition animation end **/
  if ($('.animated').is(':visible')) {
    document.querySelector('.animated').addEventListener(
      'animationend',
      function () {
        this.classList.remove('animated')
      },
      false
    )
  }

  $('.wistia_container_embeded').click(function () {
    var wistia_id = $(this).attr('id').split('-')[1]
    if ($('.wistia_async_' + wistia_id).length == 0) {
      $(this).prepend(
        '<div class="sk-spinner sk-spinner-three-bounce dispatch-loader wistia-loader"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div><div class="sk-bounce3"></div> </div>'
      )
      $(this).addClass('wistia_async_' + wistia_id)
      setTimeout(function () {
        $('#wistia-' + wistia_id + '-1')
          .children()
          .children()
          .children(':first')
          .trigger('click')
      }, 5000)
    }
  })

  $('.wistia_container_embeded_btn').click(function () {
    var container_id = $(this).attr('id')
    var wistia_id = container_id.split('-')[1]
    if ($('.wistia_async_' + wistia_id).length == 0) {
      show_wait_screen({
        message: 'Please wait while loading...',
        modalId: 'myModal',
      })
      var wistia_container = this
      $(this).addClass('wistia_async_' + wistia_id)
      var count = 0
      var wistiaInterval = setInterval(function () {
        count++
        if ($('.wistia_async_' + wistia_id).length != 0 || count > 5) {
          setTimeout(function () {
            hide_wait_screen()
            $(wistia_container).find('.wistia_click_to_play').trigger('click')
          }, 2000)
          clearInterval(wistiaInterval)
        }
      }, 500)
    }
  })

  if ($('.wistia_embed').length) {
    window.addEventListener(
      'orientationchange',
      function (e) {
        $('.wistia_popover_overlay').trigger('click')
        trialVisible()
      },
      true
    )
  }
  $('#myModal').on('shown.bs.modal', function () {
    modalPopup()
  })
})

//reset appfilter
function resetSlider() {
  $('.app-filter').addClass('appFilter_isOff')
  $('body').removeClass('modal-open')
}

function appfilter() {
  var _filter = $('.app-filter')
  var _overly = $('#overlay_div')

  if (!_filter.is(':animated')) {
    if (_filter.hasClass('appFilter_isOff')) {
      _overly.css({ zIndex: 2033 }).fadeIn()
      _filter
        .addClass('appFilter_isOn')
        .show()
        .animate({ right: 0 }, 400, 'linear', function () {
          _filter.removeClass('appFilter_isOff')
          $('body,html').addClass('modal-open')
        })
    } else {
      _filter.animate({ right: -250 }, 500, 'linear', function () {
        _filter
          .addClass('appFilter_isOff')
          .removeClass('appFilter_isOn')
          .removeAttr('style')
        $('body,html').removeClass('modal-open')
      })
      _overly.hide().css({ zIndex: '' })
    }
  }
}

// mobile pagination
function mobiPaging() {
  var notinclude = $(
    ".pagination li:not('.pagination li:first-child, .pagination li:last-child, .pagination li:nth-last-child(2)')"
  )
  var containerWidth =
    $('.pagination').outerWidth(true) -
    ($('.pagination li:nth-last-child(2)').outerWidth(true) + 0)
  if (window.matchMedia('(max-width: 991px)').matches) {
    notinclude.css({ marginRight: '' })
    $.each(notinclude, function (k, v) {
      containerWidth = containerWidth - $(v).outerWidth(true)
    })
    $(notinclude).css({ marginRight: containerWidth / notinclude.length })
  } else {
    notinclude.css({ marginRight: '' })
  }
}

/*
 * This method is to make breadcrumbs responsive across all screen size.
 * It calculates the entire width of the breadcrumb container and divide it equally among the breadcrumb(for ex if the container
 * width is 300 and 3 breadcrumbs are coming. then it will assign 100 to each breadcrumb)
 *If any breadcrumb(s) has width less than that, it will calculate that the unused width and assign it to the rest of the breadcrumbs
 * */
function responsiveBreadCrumbs() {
  var breadCrumbsContainerWidth = $('ol.breadcrumb').outerWidth(true)
  var breadCrumbs = $('ol.breadcrumb li')
  var totalBreadCrumbsWidth = 0
  var breadCrumbsExceedLength = [],
    breadCrumbsWithInLength = []
  var minBreadCrumbsWidth = breadCrumbsContainerWidth / breadCrumbs.length

  jQuery.each(breadCrumbs, function (i, val) {
    /*This is to remove the width if this method has already applied some width on li.Mainly for orientation and window resize purpose.*/
    $(this).css('width', 'auto')

    var breadCrumbWidth = $(this).width() + 0.062 * $(this).width()
    totalBreadCrumbsWidth = totalBreadCrumbsWidth + breadCrumbWidth
    if (breadCrumbWidth <= minBreadCrumbsWidth) {
      breadCrumbsWithInLength.push(val)
    } else {
      breadCrumbsExceedLength.push(val)
    }
    /*If the breadcrumbs is coming in two line.Here we need to make breadcrumb responsive */
    if (
      breadCrumbs.length == i + 1 &&
      totalBreadCrumbsWidth > breadCrumbsContainerWidth
    ) {
      var unusedWidth = 0
      jQuery.each(breadCrumbsWithInLength, function (i, val) {
        unusedWidth = unusedWidth + (minBreadCrumbsWidth - $(this).width())
      })
      minBreadCrumbsWidth =
        minBreadCrumbsWidth + unusedWidth / breadCrumbsExceedLength.length - 15
      jQuery.each(breadCrumbsExceedLength, function (i, val) {
        $(this).width(minBreadCrumbsWidth)
      })
    }
  })
}
// modal window set on browser resize
function modalPopup() {
  var _self = $('#myModal')
  var getHeaderFooterHeight =
    _self.find('.modal-header').outerHeight(true) +
    _self.find('.modal-footer').outerHeight(true) +
    30
  if (window.matchMedia('(max-width: 768px)').matches && _self.is(':visible')) {
    _self.find('.modal-body').height(window.innerHeight - getHeaderFooterHeight)
    _self.find('.modal-footer').addClass('text-xs-center')
    $('body').addClass('modal-open').css('padding-right', '')
  } else if (_self.is(':visible')) {
    _self.find('.modal-body').css('height', ' ')
    $('body').addClass('modal-open').css('padding-right', 15)
  }
}

/*
 * pass the selector and navigates to its page
 *
 * */
window.goToFirstHref = function (selector) {
  window.location.href = $(selector).attr('href')
}

/*
 * This is to hide modal if browser back button is pressed
 * */

window.onpageshow = function (event) {
  if (event.persisted) {
    if ($('#myModal').length) {
      $('#myModal').modal('hide')
    }
  }
}

function managing_users_check() {
  if (window.matchMedia('(max-width: 991px)').matches) {
    if ($('#assumed_identity').is(':visible')) {
      checkBannerVisible('.managing_users')
    } else if ($('#smartbanner').is(':visible')) {
      checkBannerVisible('#smartbanner')
    }
  } else {
    resetHeader()
  }
}
function resetHeader() {
  $('#hamburger, nav[role="navigation"]').css('top', '')
  $('header').css('top', '')
  $('.trial-banner').css('top', '50px')
  if (window.removePadding !== true) {
    $('body').css('padding-top', '0px').addClass('top-padding-50')
  } else {
    $('body').css('padding-top', '0px')
  }
  $('aside').css('top', '0px')
  $('#assumed_identity').css({ height: '0px', background: '#f3f3f4' })
}
function checkBannerVisible(containerDiv) {
  if ($(containerDiv).is(':visible')) {
    var heightofdiv = $(containerDiv).height()
    $('body').removeClass('top-padding-50')
    $('#hamburger').css('top', heightofdiv + 'px')
    $('header').css('top', heightofdiv + 'px')
    $('.trial-banner').css('top', heightofdiv + 50 + 'px')
    if ($('#top_nav').is(':visible')) {
      $('body').css('padding-top', heightofdiv + 50 + 'px')
    }
    $('aside').css('top', heightofdiv + 'px')
    $('#assumed_identity').css({
      height: heightofdiv + 'px',
      background: '#ffffff',
    })
    $('header nav[role="navigation"]').css('top', heightofdiv)
    $('#smartbanner:visible').css('position', 'fixed')
  }
}

window.handleFeatureNotOnIndividualPlan = function (feature_name) {
  $('#myModal').removeData('bs.modal')
  $('.modal-title').html(
    '<img alt="Feature Not Supported" class="img-responsive img-center p-w-lg" src="/assets/IndividualPlan/locked-features.png"><h3 class="p-w-xl">Sorry, your plan doesn\'t include this feature</h3>'
  )
  $('.modal-body').addClass('text-center')
  $('.modal-body').html(
    feature_name +
      " isn't included in our Individual Plan.  Discover a pricing plan that will let you keep going"
  )
  $('.modal-footer').html(
    '<button class="btn btn-primary btn-outline btn-sm" data-dismiss="modal" href="javascript:;">Not Now</button><button name="button" type="button" class="btn btn-primary btn-sm" onclick="location.href = \'/show_pricing_plans\'">Select a Plan</button>'
  )
  $('#myModal').modal('show')
  $.ajax({
    url:
      '/users/notify_sales_non_freemium_feature?feature_name=' +
      encodeURIComponent(feature_name),
    context: document.body,
  })
}
